<template>
    <div class="topology-container">
        <div ref="chartContainer" class="chart-container"></div>
        <!-- 添加缩放控制按钮 -->
        <div class="zoom-controls">
            <button class="zoom-btn" @click="zoomIn" title="放大">+</button>
            <button class="zoom-btn" @click="zoomOut" title="缩小">-</button>
            <button class="zoom-btn" @click="resetZoom" title="重置缩放">
                <i class="el-icon-refresh"></i>
            </button>
            <button class="zoom-btn full-view-btn" @click="showFullView" title="显示全图">
                <i class="el-icon-view"></i>
            </button>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import { getTopology } from '@/network/system-framework'

export default {
    name: 'SystemFramework2',
    data() {
        return {
            chart: null,
            scale: 0.65, // 将初始缩放比例从0.3调整为更合适的0.65
            minScale: 0.2, // 提高最小缩放限制
            maxScale: 3.0,
            // 添加定时器ID变量
            intervalId: null
        }
    },
    methods: {
        // 放大功能
        zoomIn() {
            if (this.scale < this.maxScale) {
                this.scale = Math.min(this.scale * 1.2, this.maxScale);
                this.applyZoom();
            }
        },
        // 缩小功能
        zoomOut() {
            if (this.scale > this.minScale) {
                this.scale = Math.max(this.scale / 1.2, this.minScale);
                this.applyZoom();
            }
        },
        // 重置缩放
        resetZoom() {
            this.scale = 0.65; // 调整为更合适的缩放比例
            this.applyZoom();
            this.centerView(); // 居中显示
        },
        // 添加显示全图方法
        showFullView() {
            // 计算合适的缩放比例
            const container = this.$refs.chartContainer;
            const topologyContainer = document.querySelector('.topology-container');
            
            if (container && topologyContainer) {
                const containerWidth = container.scrollWidth;
                const containerHeight = container.scrollHeight;
                const viewportWidth = topologyContainer.clientWidth;
                const viewportHeight = topologyContainer.clientHeight;
                
                // 计算适合视图的缩放比例
                const scaleX = viewportWidth / containerWidth;
                const scaleY = viewportHeight / containerHeight;
                
                // 选择较小的缩放比例，确保全部内容可见，但不要过小
                const calculatedScale = Math.min(scaleX, scaleY) * 0.95; // 缩放因子从0.9调整为0.95
                
                // 确保缩放不会太小
                this.scale = Math.max(calculatedScale, 0.4); // 设置下限为0.4
                
                // 应用缩放并居中
                this.applyZoom();
                this.centerView();
            }
        },
        // 应用缩放
        applyZoom() {
            const container = this.$refs.chartContainer;
            if (container) {
                container.style.transform = `scale(${this.scale})`;
                container.style.transformOrigin = 'top left';
            }
        },
        // 居中视图
        centerView() {
            const topologyContainer = document.querySelector('.topology-container');
            const container = this.$refs.chartContainer;
            
            if (topologyContainer && container) {
                // 计算居中所需的滚动位置
                const scaledWidth = container.scrollWidth * this.scale;
                const scaledHeight = container.scrollHeight * this.scale;
                
                // 居中滚动位置
                const scrollLeft = (scaledWidth - topologyContainer.clientWidth) / 2;
                const scrollTop = (scaledHeight - topologyContainer.clientHeight) / 2;
                
                // 平滑滚动到指定位置
                topologyContainer.scrollTo({
                    left: Math.max(0, scrollLeft),
                    top: Math.max(0, scrollTop),
                    behavior: 'smooth'
                });
            }
        },
        // 添加定时刷新方法
        refreshData() {
            getTopology().then(res => {
                console.log('定时刷新拓扑数据', res);
                // 这里可以添加更新图表的逻辑
                // 例如重新处理数据并更新图表
            }).catch(err => {
                console.error('刷新拓扑数据失败', err);
            });
        },
        
        // 初始化定时器
        initInterval() {
            // 创建10秒钟的定时器
            this.intervalId = setInterval(() => {
                this.refreshData();
            }, 10000); // 10秒 = 10000毫秒
            
            // 使用Vuex存储定时器对象
            this.$store.dispatch('addIntervalObj', {
                id: 'systemFrameworkInterval',
                interval: this.intervalId
            });
        }
    },
    mounted() {
        getTopology().then(res => {
            console.log(res, 'res')
            const serverDevice = res.data.serverDevice;
            const gatewayDevice = res.data.gatewayDevice;
            const gatewayDeviceNames = Object.keys(gatewayDevice);
            console.log(gatewayDeviceNames, 'gatewayDeviceNames')
            
            // 设置图表容器的大小
            this.$refs.chartContainer.style.width = '4000px';
            this.$refs.chartContainer.style.height = '2500px';
            
            this.chart = echarts.init(this.$refs.chartContainer)
    
            const nodes = []
            const links = []
    
            // 调整布局以适应更大的容器
            // 顶层结构：汇聚主、汇聚备、汇聚汇总、KE备机
            nodes.push(
                { 
                    name: '汇聚主', 
                    x: 2000, // 移到水平中心位置
                    y: 150, // 顶部留出一些空间
                    symbol: `image://${require('@/assets/images/system-framework/device.png')}`,
                    symbolSize: [60, 60], 
                    itemStyle: { color: 'transparent' },
                    z: 3,
                    label: {
                        show: true, // 启用标签显示
                        position: 'bottom',
                        distance: 5,
                        backgroundColor: 'rgba(11, 29, 53, 0.85)',
                        padding: [2, 4],
                        borderRadius: 2,
                        color: '#fff',
                        fontSize: 12
                    }
                },
                { 
                    name: '汇聚汇总', 
                    x: 2000, 
                    y: 250, 
                    symbol: 'none',
                    symbolSize: 0, 
                    itemStyle: { color: 'transparent' }, 
                    label: { show: false },
                    z: 3
                }
            )
    
            // 为主线添加水平分支点（不可见）
            nodes.push(
                {
                    name: 'ke主分支点',
                    x: 1500,
                    y: 250,
                    symbol: 'none',
                    symbolSize: 0,
                    itemStyle: { color: 'transparent' },
                    label: { show: false },
                    z: 1
                }
            )
    
            // KE备机节点 - 增加间距
            const keDevices = [];
            // 计算位置的基准点
            const keDevicesBaseX = 500;
            const keDevicesSpacing = 300; // 设备间距增大
            const keDevicesBaseY = 350;
    
            // 遍历 serverDevice 数据并创建设备节点
            serverDevice.forEach((device, index) => {
                keDevices.push({ 
                    name: device.name, 
                    x: keDevicesBaseX + index * keDevicesSpacing, 
                    y: keDevicesBaseY, 
                    symbol: `image://${require(device.status === 1 ? 
                        '@/assets/images/system-framework/device1.png' : 
                        '@/assets/images/system-framework/device1_offline.png')}`,
                    symbolSize: [50, 50], 
                    itemStyle: { color: 'transparent' },
                    z: 3,
                    label: {
                        show: true,
                        position: 'bottom',
                        distance: 5,
                        backgroundColor: 'rgba(11, 29, 53, 0.85)',
                        padding: [2, 4],
                        borderRadius: 2,
                        color: '#fff',
                        fontSize: 12,
                        formatter: function() {
                            return `${device.name} (${device.ip})`;
                        }
                    }
                });
            });
    
            // 添加KE备机节点
            nodes.push(...keDevices);
            
            // 使用双连接点系统创建直角连接
            keDevices.forEach((device, index) => {
                // 1. 从主分支点到设备正上方的垂直连接点
                const topNodeName = `ke顶部连接点${index+1}`;
                nodes.push({
                    name: topNodeName,
                    x: device.x,
                    y: 250, // 与主分支点同高度
                    symbol: 'none',
                    symbolSize: 0,
                    itemStyle: { color: 'transparent' },
                    label: { show: false },
                    z: 1
                });
                
                // 2. 从设备正上方到设备的垂直连接点
                const centerNodeName = `ke中心连接点${index+1}`;
                nodes.push({
                    name: centerNodeName,
                    x: device.x,
                    y: keDevicesBaseY, // 与设备中心同高度
                    symbol: 'none',
                    symbolSize: 0,
                    itemStyle: { color: 'transparent' },
                    label: { show: false },
                    z: 1
                });
                
                // 主分支点到顶部连接点（水平线）
                links.push({
                    source: 'ke主分支点',
                    target: topNodeName,
                    lineStyle: { opacity: 0.8, z: 1, color: '#0E4475' }
                });
                
                // 顶部连接点到中心连接点（垂直线）
                links.push({
                    source: topNodeName,
                    target: centerNodeName,
                    lineStyle: { opacity: 0.8, z: 1, color: '#0E4475' }
                });
                
                // 中心连接点到KE备机（水平线）
                links.push({
                    source: centerNodeName,
                    target: device.name,
                    lineStyle: { opacity: 0.8, z: 1, color: '#0E4475' }
                });
            });
            
            // 添加汇总到主分支点的线
            links.push({ 
                source: '汇聚汇总', 
                target: 'ke主分支点', 
                lineStyle: { opacity: 0.8, z: 1, color: '#0E4475' } 
            });
    
            nodes.push({ 
                name: '汇聚出口', 
                x: 2000, 
                y: 450, 
                symbol: 'none',
                symbolSize: 0, 
                itemStyle: { color: 'transparent' }, 
                label: { show: false },
                z: 3
            })
    
            // 基本连线
            links.push(
                { source: '汇聚主', target: '汇聚汇总', lineStyle: { opacity: 0.8, z: 1, color: '#0E4475' } },
                { source: '汇聚汇总', target: '汇聚出口', lineStyle: { opacity: 0.8, z: 1, color: '#0E4475' } }
            )
    
            // 添加中继横线节点作为主干线 - 增加间距
            const midLineSpacing = 350 // 机房间距增大
            const midLineY = 600  // 距离顶部设备更远
            const midLineXStart = 200
            
            // 处理网关设备数据
            const gatewayNodes = [];
    
            // 遍历每个机房
            Object.keys(gatewayDevice).forEach((roomName, roomIndex) => {
                // 为每个机房创建一个节点作为组标题
                const roomNodeName = `机房-${roomName}`;
                const roomNodeX = midLineXStart + roomIndex * midLineSpacing;
                
                // 添加机房节点
                nodes.push({
                    name: roomNodeName,
                    x: roomNodeX,
                    y: midLineY,
                    symbol: 'circle',
                    symbolSize: 6, // 略微增大点的大小
                    itemStyle: { color: 'rgba(14, 68, 117, 0.7)' },
                    label: {
                        show: true,
                        position: 'top',
                        distance: 5,
                        backgroundColor: 'rgba(11, 29, 53, 0.85)',
                        padding: [2, 4],
                        borderRadius: 2,
                        color: '#fff',
                        fontSize: 14, // 增大字体
                        formatter: function() {
                            return roomName;
                        }
                    },
                    z: 3
                });
                
                gatewayNodes.push(roomNodeName);
                
                // 连接相邻机房节点
                if (roomIndex > 0) {
                    links.push({ 
                        source: gatewayNodes[roomIndex - 1], 
                        target: roomNodeName,
                        lineStyle: { opacity: 0.8, z: 1, color: '#0E4475' }
                    });
                }
                
                // 获取该机房下的所有设备
                const devices = gatewayDevice[roomName];
                
                // 垂直排列设备 - 增加间距
                devices.forEach((device, deviceIdx) => {
                    const deviceName = device.name;
                    const deviceY = midLineY + 100 + deviceIdx * 80; // 设备间距增大
                    
                    // 添加设备节点
                    nodes.push({
                        name: deviceName,
                        x: roomNodeX,
                        y: deviceY,
                        symbol: `image://${require(device.status === 1 ? 
                            '@/assets/images/system-framework/device2.png' : 
                            '@/assets/images/system-framework/device2_offline.png')}`,
                        symbolSize: [80, 30],
                        itemStyle: { color: 'transparent' },
                        z: 3,
                        label: {
                            show: true,
                            position: 'right',
                            backgroundColor: 'rgba(11, 29, 53, 0.85)',
                            padding: [2, 4],
                            borderRadius: 2,
                            color: '#fff',
                            formatter: function() {
                                return `${deviceName} (${device.ip})`;
                            }
                        }
                    });
                    
                    // 连接设备到机房节点
                    links.push({ 
                        source: roomNodeName, 
                        target: deviceName,
                        lineStyle: { opacity: 0.8, z: 1, color: '#0E4475' }
                    });
                });
            });
    
            // 添加主干链路段A 的说明文字节点
            nodes.push({
                name: '主干链路段A',
                x: midLineXStart + 1 * midLineSpacing,
                y: midLineY - 40,
                symbol: 'none',
                symbolSize: 0,
                label: {
                    show: true,
                    formatter: '主干链路段A',
                    color: '#fff',
                    fontSize: 16, // 增大字体
                    position: 'top',
                    backgroundColor: 'rgba(11, 29, 53, 0.85)',
                    padding: [2, 4],
                    borderRadius: 2
                },
                z: 4
            })
    
            // 使用垂直连接点实现直角连接到主干线
            const verticalConnector = {
                name: '汇聚垂直连接点',
                x: 2000,
                y: midLineY,
                symbol: 'none',
                symbolSize: 0,
                itemStyle: { color: 'transparent' },
                label: { show: false },
                z: 1
            };
            nodes.push(verticalConnector);
            
            // 汇聚出口到垂直连接点（垂直线）
            links.push({ 
                source: '汇聚出口', 
                target: '汇聚垂直连接点',
                lineStyle: { opacity: 0.8, z: 1, color: '#0E4475' }
            });
            
            // 垂直连接点到第一个机房节点（水平线）
            if (gatewayNodes.length > 0) {
                links.push({ 
                    source: '汇聚垂直连接点', 
                    target: gatewayNodes[0],
                    lineStyle: { opacity: 0.8, z: 1, color: '#0E4475' }
                });
            }
    
            this.chart.setOption({
                backgroundColor: '#001325',
                tooltip: { show: false },
                animation: false,
                series: [{
                    type: 'graph',
                    layout: 'none',
                    coordinateSystem: null,
                    roam: false,
                    z: 2,
                    label: {
                        show: true,
                        position: 'right',
                        z: 4
                    },
                    edgeSymbol: ['none', 'none'],
                    edgeSymbolSize: [0, 0],
                    lineStyle: {
                        color: '#0E4475',
                        width: 2, // 略微增加线宽
                        curveness: 0,
                        opacity: 0.8,
                        z: 1
                    },
                    data: nodes,
                    links: links,
                    emphasis: {
                        label: {
                            z: 5
                        }
                    }
                }]
            });
            
            // 添加快捷键支持
            document.addEventListener('keydown', (e) => {
                if (e.ctrlKey) {
                    if (e.key === '=' || e.key === '+') {
                        e.preventDefault();
                        this.zoomIn();
                    } else if (e.key === '-') {
                        e.preventDefault();
                        this.zoomOut();
                    } else if (e.key === '0') {
                        e.preventDefault();
                        this.resetZoom();
                    }
                }
            });
            
            // 添加滚轮缩放支持
            const topologyContainer = document.querySelector('.topology-container');
            if (topologyContainer) {
                topologyContainer.addEventListener('wheel', (e) => {
                    if (e.ctrlKey) {
                        e.preventDefault();
                        if (e.deltaY < 0) {
                            this.zoomIn();
                        } else {
                            this.zoomOut();
                        }
                    }
                });
            }
            
            // 在图表加载完成后应用初始缩放和居中
            this.$nextTick(() => {
                // 初始化缩放
                this.applyZoom();
                
                // 短暂延迟后居中显示，确保DOM已完全更新
                setTimeout(() => {
                    this.scale = 0.65; 
                    this.applyZoom();
                    this.centerView();
                }, 300);
            });
        });
        
        // 初始化定时器
        this.initInterval();
    },
    beforeDestroy() {
        // 清理事件监听器
        document.removeEventListener('keydown', this.handleKeyDown);
        
        // 清除定时器
        if (this.intervalId) {
            clearInterval(this.intervalId);
            // 从Vuex中移除定时器对象
            this.$store.dispatch('removeIntervalObj', 'systemFrameworkInterval');
        }
        
        // Clean up chart when component is destroyed
        if (this.chart) {
            this.chart.dispose();
            this.chart = null;
        }
    }
}
</script>

<style scoped>
.topology-container {
    width: 100%;
    height: calc(100vh - 55px);
    background-color: #001325;
    overflow: auto; /* 启用滚动条 */
    position: relative;
}

.chart-container {
    width: 4000px;
    height: 2500px;
    position: relative;
    transform-origin: top left; /* 设置缩放的起点 */
}

/* 增强滚动条样式 */
.topology-container::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #001325;
}

.topology-container::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 0;
    background-color: #001325;
}

.topology-container::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: #0E4475;
    border: 2px solid #001325;
}

.topology-container::-webkit-scrollbar-thumb:hover {
    background-color: #1a6db3;
}

/* 滚动条交叉部分的样式 */
.topology-container::-webkit-scrollbar-corner {
    background-color: #001325;
}

/* Firefox滚动条样式 */
.topology-container {
    scrollbar-width: thin;
    scrollbar-color: #0E4475 #001325;
}

/* 修改缩放控件样式为fixed定位 */
.zoom-controls {
    position: fixed; /* 改为固定定位，不随滚动而移动 */
    top: 100px;
    right: 20px;
    z-index: 100; /* 提高z-index确保按钮始终在最上层 */
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.zoom-btn {
    width: 36px;
    height: 36px;
    background-color: rgba(14, 68, 117, 0.8);
    border: 1px solid #0E4475;
    border-radius: 4px;
    color: white;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s;
}

.zoom-btn:hover {
    background-color: rgba(20, 100, 170, 0.8);
}

.zoom-btn:active {
    transform: translateY(1px);
}

/* 添加全图按钮样式 */
.full-view-btn {
    margin-top: 10px; /* 与其他按钮区分 */
    background-color: rgba(30, 144, 255, 0.8); /* 使用不同颜色以便识别 */
}

.full-view-btn:hover {
    background-color: rgba(65, 162, 255, 0.9);
}
</style>